import { CHANGE_EVENT } from '@hongluan-ui/constants'
import { isNumber } from '@hongluan-ui/utils'

import type { ExtractPropTypes } from 'vue'
import type Steps from './steps.vue'

export const stepsProps = {
  /**
   * @description the spacing of each step, will be responsive if omitted. Supports percentage.
   */
  gap: {
    type: [Number, String],
    default: '',
  },
  itemPadding: {
    type: [Number, String],
    default: '',
  },
  /**
   * @description current activation step
   */
  active: {
    type: Number,
    default: 0,
  },
  /**
   * @description display direction
   */
  dir: {
    type: String,
    default: 'horizontal',
    validator: (val: string): boolean => ['horizontal', 'vertical', 'inline'].includes(val),
  },
  block: {
    type: Boolean,
    default: false,
  },
  /**
   * @description center title and description
   */
  center: {
    type: Boolean,
    default: false,
  },
  /**
   * @description whether to apply simple theme
   */
  simple: {
    type: Boolean,
    default: false,
  },
  /**
   * @description status of end step
   */
  finishStatus: {
    type: String,
    default: 'finish',
    validator: (val: string): boolean => ['wait', 'process', 'finish', 'error', 'success'].includes(val),
  },
  /**
   * @description status of current step
   */
  processStatus: {
    type: String,
    default: 'process',
    validator: (val: string): boolean => ['wait', 'process', 'finish', 'error', 'success'].includes(val),
  },
}
export type StepsProps = ExtractPropTypes<typeof stepsProps>

export const stepsEmits = {
  [CHANGE_EVENT]: (newVal: number, oldVal: number) =>
    isNumber(newVal) && isNumber(oldVal),
}
export type StepsEmits = typeof stepsEmits
export type StepsInstance = InstanceType<typeof Steps>
